// extracted by mini-css-extract-plugin
export var hotspotBtn = "HotspotOverlayImage-module--hotspotBtn--3bbe3";
export var noOutline = "HotspotOverlayImage-module--noOutline--2-btR";